module.exports = __webpack_public_path__ + "img/logo.86a13a1f.jpg";